import {
   FeedbackPrompt,
   isFeedbackSurface,
   useFeedbackApiTransport,
} from '@ifixit/feedback-prompt';
import { useTranslations } from '@ifixit/i18n/hooks';
import initializeComponent from 'Shared/react-initialize';

interface FeedbackPromptMountProps {
   surface: string;
   docid?: number;
}

function FeedbackPromptMount({ surface, docid }: FeedbackPromptMountProps) {
   const t = useTranslations('FeedbackPrompt.questions');
   const transport = useFeedbackApiTransport(docid);

   if (!isFeedbackSurface(surface)) {
      return null;
   }

   return <FeedbackPrompt surface={surface} question={t(surface)} transport={transport} />;
}

initializeComponent('FeedbackPrompt', FeedbackPromptMount);
